import {Modalator} from 'hegyd/core/resources/assets/js/utils/Modalator.js'

export default class SelectAddressItem extends HTMLDivElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorChangeAddress() {
        return ".choose-address";
    }

    initSelectAddressesModal( link, container) {
        var url = link.dataset.href;

        var modal = new Modalator();

        modal.initRemoteModal('#modal-select-address', url, null, function( data ) {
            container.updateCartViews( data );
        });
    }

    initEvents() {
        this.querySelector(this.getSelectorChangeAddress()).addEventListener('click',  (e) => {
            e.preventDefault();

            this.initSelectAddressesModal(e.target, this.mainContainer);
        });
    }
};

